import { render, staticRenderFns } from "./biddingLinkList.vue?vue&type=template&id=066a7807&scoped=true"
import script from "./biddingLinkList.vue?vue&type=script&lang=js"
export * from "./biddingLinkList.vue?vue&type=script&lang=js"
import style0 from "./biddingLinkList.vue?vue&type=style&index=0&id=066a7807&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "066a7807",
  null
  
)

export default component.exports